import React from "react";
import {useFormContext} from "react-hook-form";
import {DateTimeField} from "src/packages/react-hook-form-mui";

export default function FormDateTimeField({name, ...props}) {
  const {register, formState: {errors, isSubmitting}} = useFormContext();

  return (
    <DateTimeField
      name={name}
      register={register}
      errors={errors}
      disabled={isSubmitting}
      {...props}
    />
  );
}
